import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Leaf, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Mínimo 6 caracteres"); return; }
    if (password !== confirm) { toast.error("As palavras-passe não coincidem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Palavra-passe atualizada");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--bone)] grid place-items-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-[var(--forest)] text-white grid place-items-center"><Leaf className="w-5 h-5"/></div>
          <div>
            <div className="font-heading text-lg text-[var(--forest)]">CARING</div>
            <div className="eyebrow -mt-0.5">Referências</div>
          </div>
        </div>

        <div className="eyebrow mt-8">Nova palavra-passe</div>
        <h1 className="font-heading text-4xl mt-2">Defina a sua palavra-passe</h1>
        <p className="text-[var(--ink-soft)] mt-2">Escolha algo seguro com pelo menos 6 caracteres.</p>

        {done ? (
          <div className="card-surface p-6 mt-6 space-y-3">
            <div className="chip chip-green w-fit"><CheckCircle2 className="w-3 h-3"/> Atualizada</div>
            <p className="text-sm text-[var(--ink-soft)]">A sua palavra-passe foi atualizada com sucesso. A redirecionar para o login…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="card-surface p-6 mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium">Nova palavra-passe</label>
              <div className="mt-1.5 relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-soft)]"/>
                <input
                  type="password"
                  data-testid="reset-password-input"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-10 pr-3 py-3 rounded-xl bg-[var(--muted)] border border-[var(--border)] focus:outline-none focus:ring-2 focus:ring-[var(--forest)]"
                />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium">Confirmar palavra-passe</label>
              <div className="mt-1.5 relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-soft)]"/>
                <input
                  type="password"
                  data-testid="reset-confirm-input"
                  required
                  minLength={6}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-10 pr-3 py-3 rounded-xl bg-[var(--muted)] border border-[var(--border)] focus:outline-none focus:ring-2 focus:ring-[var(--forest)]"
                />
              </div>
            </div>
            <button disabled={busy} className="pill-btn pill-primary w-full justify-center" data-testid="reset-submit-btn">
              {busy ? "A guardar…" : "Guardar nova palavra-passe"}
            </button>
            <Link to="/login" className="block text-center text-sm text-[var(--ink-soft)] underline mt-2">Cancelar</Link>
          </form>
        )}
      </div>
    </div>
  );
}
